import { GhostButton } from "@certn/cascadia-react";
import { Skeleton } from "@certn/cascadia-react/patterns/skeleton/Skeleton";
import { css } from "@emotion/css";
import { useTranslation } from "react-i18next";

import { FilterRequestorType } from "./FilterRequestorType";
import { GroupFilter } from "./GroupFilter";
import { SortByDateFilter } from "../../components/sort-by-date-filter/SortByDateFilter";
import { useQueryParams } from "../../hooks/useQueryParams";

export function TasksFilters({ isLoading }: { isLoading?: boolean }) {
  const { clearParam, params } = useQueryParams();
  const { t } = useTranslation();

  if (isLoading) {
    return <Skeleton />;
  }

  return (
    <div className={styles.container}>
      <div className={styles.filters}>
        <SortByDateFilter />
        <FilterRequestorType />
        <GroupFilter />
        {Object.keys(params).length > 0 && (
          <GhostButton
            size="small"
            testID="clear-filters"
            onPress={() => {
              for (const param in params) {
                if (param !== "page-count") {
                  clearParam(param);
                }
              }
            }}
          >
            {t("Clear filters")}
          </GhostButton>
        )}
      </div>
    </div>
  );
}

const styles = {
  container: css({
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "wrap",
    rowGap: "var(--space-3)",
    columnGap: "var(--space-2)",
    flexShrink: 1,
  }),
  filters: css({
    display: "flex",
    rowGap: "var(--space-3)",
    columnGap: "var(--space-2)",
    flexWrap: "wrap",
    flexShrink: 1,
    flexGrow: 1,
    alignItems: "flex-start",
  }),
};
